class AppConfig {

    app = "";
    menus = {};
    conf = {};

    constructor(app) {
        let conf = require(`./${app}.js`);
        this.conf = conf;
        this.app = app;
        this.calMenu();
    }

    calMenu() {
        const menuRoute = {
            'qiye': {group: 'g1', index: '/comm/qiye', title: '企业信息'},
            'baosi': {group: 'g2', index: '/comm/baosi', title: '保司信息'},
            'qiyemanager': {group: 'g3', index: '/comm/qiyemanager', title: '企业管理'},
            'baosimanager': {group: 'g3', index: '/comm/baosimanager', title: '保司管理'},
            'authmanager': {group: 'g3', index: '/comm/authmanager', title: '权限管理'},
            'productmanager': {group: 'g3', index: '/comm/productmanager', title: '保险产品管理'},
            'paymanager': {group: 'g3', index: '/comm/paymanager', title: '支付配置'},
            'sale': {group: 'g4', index: '/comm/sale', title: '购买保险'},
            'orderrecord': {group: 'g4', index: '/comm/orderrecord', title: '航意险出单记录'},
            'orderrecord2': {group: 'g4', index: '/comm/orderrecord2', title: '旅意险出单记录'},
            'financialcenter': {group: 'g5', index: '/comm/financialcenter', title: '资金明细'},
            'billCenter': {group: 'g5', index: '/comm/BillCenter', title: '月度账单'},
            'logquery': {group: 'g6', index: '/comm/logquery', title: '日志查询'},
            'grayuser': {group: 'g7', index: '/comm/grayuser', title: '灰度用户'},
            'grayrelease': {group: 'g7', index: '/comm/grayrelease', title: '灰度发版'},
        }

        const menuGroup = {
            "g1": {
                index: 'deploy-qiye',
                icon: 'el-icon-office-building',
                title: '企业信息',
            },
            'g2': {
                index: 'deploy-baosi',
                icon: 'el-icon-office-building',
                title: '保司信息',
            },
            'g3': {
                index: 'deploy-server',
                icon: 'el-icon-setting',
                title: '后台管理',
            },
            'g4': {
                index: 'deploy-yewuyuan',
                icon: 'el-icon-shopping-cart-1',
                title: '交易中心',
            },
            'g5': {
                index: 'deploy-caiwu',
                icon: 'el-icon-shopping-cart-1',
                title: '财务中心',
            },
            'g6': {
                index: 'deploy-tools',
                icon: 'el-icon-cpu',
                title: '开发工具',
            },
            'g7': {
                index: 'deploy-release',
                icon: 'el-icon-upload2',
                title: '发版设置',
            },
        }

        for (const menuKey of this.conf.menus) {
            const route = menuRoute[menuKey];
            if (!route) continue
            let menu = this.menus[route.group]
            if (!menu) {
                let group = menuGroup[route.group]
                if (!group) continue
                menu = {
                    index: group.index,
                    icon: group.icon,
                    title: group.title,
                    auth: group.auth,
                    subs: [],
                }
                this.menus[route.group] = menu
            }
            menu.subs.push({index: route.index, title: route.title})
        }
    }
}

let apps = [
    "业务员",
    "企业",
    "保司",
    "后台管理",
    "客服"
]

let configs = {}
apps.forEach((app => {
    configs[app] = new AppConfig(app);
}))

export default configs;
